import secureCookies from '@/libs/cookies'
import useJwt from '@/auth/jwt/useJwt'

const pageName = { singular: 'Customer', plural: 'Customer' }
const pageNames = { singular: 'Broadcast', plural: 'Broadcast' }

export default [
  {
    path: '/redirect-inbox-extern',
    name: 'redirect-inbox-extern',
    component: {
      render() {},
      created() {
        const token = secureCookies.getItem(useJwt.jwtConfig.storageTokenKeyName)
        const inboxUrl = process.env.VUE_APP_INBOX_KOMCHAT_URL
        window.open(`${inboxUrl}?token=${token}`, '_blank')
      },
    },
    meta: {
      resource: 'Inbox Komchat',
      action: 'manage',
    },
  },
  {
    path: '/broadcast',
    name: 'broadcast',
    component: () => import('@/views/pages/komship/customer/Broadcast.vue'),
    meta: {
      name: pageNames,
      routeDetail: 'broadcast',
      navActiveLink: 'broadcast',
      resource: 'Broadcast',
      action: 'manage',
      breadcrumb: [
        {
          text: pageNames.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/broadcast/history',
    name: 'broadcast-history',
    component: () => import('@/views/pages/komship/customer/HistoryBroadcast.vue'),
    meta: {
      name: pageNames,
      navActiveLink: 'broadcast',
      resource: 'Broadcast',
      action: 'manage',
      breadcrumb: [
        {
          text: pageNames.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/broadcast/history-lite/:id',
    name: 'broadcast-history-lite',
    component: () => import('@/views/pages/komship/customer/DetailHistoryBroadcastLite.vue'),
    meta: {
      name: pageNames,
      navActiveLink: 'broadcast',
      resource: 'Broadcast',
      action: 'manage',
      breadcrumb: [
        {
          text: pageNames.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/broadcast/history/detail/:id',
    name: 'broadcast-history-detail',
    component: () => import('@/views/pages/komship/customer/DetailHistoryBroadcast.vue'),
    meta: {
      name: pageNames,
      navActiveLink: 'broadcast',
      resource: 'Broadcast',
      action: 'manage',
      breadcrumb: [
        {
          text: pageNames.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/info-customer',
    name: 'info-customer',
    component: () => import('@/views/pages/komship/customer/InfoCustomer.vue'),
    meta: {
      name: pageName,
      routeDetail: 'detail-customer',
      navActiveLink: 'info-customer',
      resource: 'Info Customer',
      action: 'manage',
      breadcrumb: [
        {
          text: pageName.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/data-customer',
    name: 'data-customer',
    component: () => import('@/views/pages/komship/customer/DataCustomer.vue'),
    meta: {
      name: pageName,
      navActiveLink: 'data-customer',
      resource: 'Data Customer',
      action: 'manage',
      breadcrumb: [
        {
          text: pageName.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/grup-contact',
    name: 'grup-contact',
    component: () => import('@/views/pages/komship/customer/GrupKontak.vue'),
    meta: {
      name: pageNames,
      navActiveLink: 'grup-contact',
      resource: 'Group Contact',
      action: 'manage',
      breadcrumb: [
        {
          text: pageNames.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/ai-customer-service',
    name: 'ai-customer-service',
    component: () => import('@/views/pages/komship/customer/AiCustomerService.vue'),
    meta: {
      name: pageNames,
      navActiveLink: 'ai-customer-service',
      resource: 'AI Customer Service',
      action: 'manage',
      breadcrumb: [
        {
          text: pageNames.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/ai-customer-service/create',
    name: 'create-ai-customer-service',
    component: () => import('@/views/pages/komship/customer/Ai/Add.vue'),
    meta: {
      name: pageNames,
      navActiveLink: 'ai-customer-service',
      resource: 'AI Customer Service',
      action: 'manage',
      breadcrumb: [
        {
          text: pageNames.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/ai-customer-service/edit/:id',
    name: 'edit-ai-customer-service',
    component: () => import('@/views/pages/komship/customer/Ai/Add.vue'),
    meta: {
      name: pageNames,
      navActiveLink: 'ai-customer-service',
      resource: 'AI Customer Service',
      action: 'manage',
      breadcrumb: [
        {
          text: pageNames.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/grup-contact/list-contact',
    name: '/grup-contact/list-contact',
    component: () => import('@/views/pages/komship/customer/DaftarKontak.vue'),
    meta: {
      name: pageNames,
      navActiveLink: 'grup-contact',
      resource: 'Group Contact',
      action: 'manage',
      breadcrumb: [
        {
          text: pageNames.plural,
          active: true,
        },
        {
          text: pageNames.plural,
        },
      ],
    },
  },
  {
    path: '/grup-contact/list-contact-google',
    name: 'list-contact-google',
    component: () => import(
      '@/views/pages/komship/customer/Broadcast/components/ListContactGoogle.vue'
    ),
    meta: {
      name: pageNames,
      navActiveLink: 'grup-contact',
      resource: 'Group Contact',
      action: 'manage',
      breadcrumb: [
        {
          text: pageNames.plural,
          active: true,
        },
        {
          text: pageNames.plural,
        },
      ],
    },
  },
  {
    path: '/group-contact/import-google',
    name: 'import-google',
    component: () => import('@/views/pages/komship/customer/GoogleCallback.vue'),
    meta: {
      name: pageNames,
      navActiveLink: 'grup-contact',
      resource: 'Group Contact',
      action: 'manage',
      breadcrumb: [
        {
          text: pageNames.plural,
          active: true,
        },
        {
          text: pageNames.plural,
        },
      ],
    },
  },
  {
    path: '/grup-contact/create-contact',
    name: 'create-contact',
    component: () => import('@/views/pages/komship/customer/CreateNewContact.vue'),
    meta: {
      name: pageNames,
      navActiveLink: 'grup-contact',
      resource: 'Group Contact',
      action: 'manage',
      breadcrumb: [
        {
          text: pageNames.plural,
          active: true,
        },
        {
          text: pageNames.plural,
        },
      ],
    },
  },
  {
    path: '/import-from-komship',
    name: 'import-from-komship',
    component: () => import('@/views/pages/komship/customer/InputFromKomship.vue'),
    meta: {
      name: pageNames,
      navActiveLink: 'grup-contact',
      resource: 'Group Contact',
      action: 'manage',
      breadcrumb: [
        {
          text: pageNames.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/import-from-komchat-ai',
    name: 'import-from-komchat-ai',
    component: () => import(
      '@/views/pages/komship/customer/groupContact/ImportFromKomchatAI.vue'
    ),
    meta: {
      name: pageNames,
      navActiveLink: 'grup-contact',
      resource: 'Group Contact',
      action: 'manage',
      breadcrumb: [
        {
          text: pageNames.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/import-from-meta',
    name: 'import-from-meta',
    component: () => import(
      '@/views/pages/komship/customer/groupContact/ImportFromMeta.vue'
    ),
    meta: {
      name: pageNames,
      navActiveLink: 'grup-contact',
      resource: 'Group Contact',
      action: 'manage',
      breadcrumb: [
        {
          text: pageNames.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/group-contact/detail-customer/:customer_id',
    name: 'detail-customer-contact',
    component: () => import('@/views/pages/komship/customer/DetailCustomer.vue'),
    meta: {
      name: pageNames,
      navActiveLink: 'grup-contact',
      routeDetailOrder: 'detail-order',
      resource: 'Group Contact',
      action: 'manage',
      breadcrumb: [
        {
          text: pageNames.plural,
        },
        {
          text: 'Detail Customer Kontak',
          active: true,
        },
      ],
    },
  },
  {
    path: '/info-customer/detail-customer/:customer_id',
    name: 'detail-customer',
    component: () => import('@/views/pages/komship/customer/DetailCustomer.vue'),
    meta: {
      name: pageName,
      navActiveLink: 'info-customer',
      routeDetailOrder: 'detail-order',
      resource: 'Info Customer',
      action: 'manage',
      breadcrumb: [
        {
          text: pageName.plural,
        },
        {
          text: 'Detail Customer',
          active: true,
        },
      ],
    },
  },
  {
    path: '/info-customer/detail-customer/detail-order/:order_id',
    name: 'detail-order',
    component: () => import('@/views/pages/komship/customer/DetailOrder.vue'),
    meta: {
      name: 'Detail Order',
      navActiveLink: 'info-customer',
      resource: 'Info Customer',
      action: 'manage',
      breadcrumb: [
        {
          text: pageName.plural,
        },
        {
          text: 'Detail order',
          active: true,
        },
      ],
    },
  },
  {
    path: '/broadcast/send-message',
    name: 'broadcast-send-message',
    component: () => import('@/views/pages/komship/customer/SendMessage.vue'),
    meta: {
      name: pageNames,
      navActiveLink: 'broadcast',
      resource: 'Broadcast',
      action: 'manage',
      breadcrumb: [
        {
          text: pageNames.plural,
          active: true,
        },
        {
          text: 'Send Message',
          active: true,
        },
      ],
    },
  },
  {
    path: '/komchat-coins',
    name: 'komchat-coins',
    component: () => import('@/views/pages/komship/customer/KomchatCoins.vue'),
    meta: {
      name: pageNames,
      navActiveLink: 'broadcast',
      resource: 'Broadcast',
      action: 'manage',
      breadcrumb: [
        {
          text: pageNames.plural,
          active: true,
        },
        {
          text: 'Komchat Coins',
          active: true,
        },
      ],
    },
  },
]
